<hm-modal>
  <form
    [formGroup]="form"
    *ngIf="vm$ | async as vm"
    class="filters-panel__container"
  >
    <hm-filters-panel-header
      headerTitle="Floor utilization"
    ></hm-filters-panel-header>
    <main class="filters-panel__body">
      <hm-search
        formControlName="building"
        (ngModelChange)="selectBuilding()"
        [isRequired]="true"
        [optionTemplate]="buildingTemplate"
        [options]="vm.buildingsData.buildings"
        label="Office"
        optionLabelField="name"
        placeholder="Select office"
        required
      >
      </hm-search>

      <hm-search
        formControlName="floor"
        (ngModelChange)="selectFloor()"
        [isRequired]="true"
        [optionTemplate]="buildingTemplate"
        [options]="filteredFloors"
        label="Floor"
        optionLabelField="name"
        placeholder="Select floor"
        required
      >
      </hm-search>

      <dds-select
        formControlName="interval"
        [list]="buildingsDataIntervals"
        label="Interval"
        [placeholder]="'Select interval'"
        [customClass]="selectOptions.customClass"
        class="w-100"
        [isRequired]="true"
        [errorMessage]="buildIntervalErrorMessage()"
      ></dds-select>

      <dds-daterangepicker
        formControlName="dateRange"
        (dateChanged)="selectDateRange()"
        [errorMessage]="buildDateRangeErrorMessage()"
        [format]="datePickerDateFormat"
        [hmDateRangeInterval]="vm.filterValue.interval.value"
        [isManualInput]="true"
        [isRequired]="true"
        [isUTCFormat]="true"
        [maxDate]="today"
        [placeholder]="['Start date', 'End date']"
        stickerPosition="right"
        class="filters-panel__body-item"
        label="Date range"
        labelPosition="external"
        size="md"
      ></dds-daterangepicker>

      <dds-select
        formControlName="hoursType"
        [list]="hoursTypesOptions"
        [labelPosition]="selectOptions.labelPosition"
        [label]="'Hours type'"
        [size]="selectOptions.size"
        [placeholder]="'Select hours type'"
        [customClass]="selectOptions.customClass"
        [isRequired]="true"
        class="w-100"
      ></dds-select>

      <hm-radio-list
        formControlName="device"
        [isRequired]="true"
        [options]="vm.buildingsData.devices"
        optionLabelField="label"
        orientation="vertical"
        required
        title="Devices"
      >
      </hm-radio-list>
    </main>
    <hm-filters-panel-actions
      *ngIf="form"
      [form]="form"
      (applyForm)="submit()"
      [defaultFormValue]="defaultFormValue"
    ></hm-filters-panel-actions>
  </form>
</hm-modal>

<ng-template #buildingTemplate let-facility>
  {{ facility.name }}
</ng-template>
